import { useTranslation } from 'react-i18next';
import AnswerMessageContainer from './answer-message-container';

function LoadingMessage() {
  const { t } = useTranslation();

  return <AnswerMessageContainer>{t('common.loading')}</AnswerMessageContainer>;
}

export default LoadingMessage;
